export class CodeHistorySnapshot {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // Constructor
    constructor(model) {
        this.scanId = model.scanId;
        this.scanTimestamp = new Date(model.scanTimestamp);
        this.totalComponents = model.totalComponents;
        this.componentsWithUsage = Number(model.componentsWithUsage);
        this.componentsWithStorybook = Number(model.componentsWithStorybook);
        this.totalUsages = Number(model.totalUsages);
    }
}
